import { render, staticRenderFns } from "./YoutubeVideoPlayer.vue?vue&type=template&id=5b3aca74"
import script from "./YoutubeVideoPlayer.vue?vue&type=script&lang=js"
export * from "./YoutubeVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "vue-dialog-drag/dist/vue-dialog-drag.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./YoutubeVideoPlayer.vue?vue&type=style&index=1&id=5b3aca74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports